<template>
    <div class="bg-white px-3 index">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-cascader v-model="lb_value" size="small" :props="lb_props" :options="lb_options" clearable>
                        </el-cascader>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="height" class="tableLimit">
                <el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="图片">
                    <template slot-scope="{row}">
                        <div class="u-f u-wrap">
                            <el-image style="width: 50px; height: 50px;margin-right:2px"
                                v-for="(img,index) in row.titlepic" :key="index" :src="img.url" :fit="'cover'"
                                :preview-src-list="[img.url]"></el-image>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="category.category_name" label="分类" show-overflow-tooltip width="100">
                </el-table-column>
                <el-table-column prop="user.nickname" label="用户" width="100">
                    <template slot-scope="{row}">
                        <span>{{row.user.nickname}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="添加时间" width="180"></el-table-column>
                <el-table-column prop="status" label="状态" show-overflow-tooltip width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.status==0">待审核</span>
                        <span v-else-if="scope.row.status==1" style="color:green">审核通过</span>
                        <span v-else-if="scope.row.status==2" style="color:red">审核未通过</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="380" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" type="info" v-if="scope.row.is_top!=1" plain
                            @click="handle_top(scope.row,1)">置顶</el-button>
                        <el-button size="mini" type="primary" v-else plain @click="handle_top(scope.row,0)">取消置顶
                        </el-button>
                        <el-button size="mini" type="warning" @click="handleexam(scope.$index, scope.row)">审核
                        </el-button>
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row,scope.$index)">编辑</el-button>
                        <el-button size="mini" type="primary" @click="detailbtn(scope.row,scope.$index)">详情</el-button>
                        <el-button size="mini" type="danger" @click="handleDelet(scope.row,scope.$index)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog title="录入" :visible.sync="dialogVisible" center top="20px" width="70%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <el-form-item label="医生" prop='ry_value'>
                        <el-select v-model="ruleForm.ry_value" placeholder="请选择" size="small" filterable clearable>
                            <el-option v-for="item in  doc_options" :key="item.id" :label="item.nickname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="类别" prop='lb_value'>

                        <el-cascader v-model="ruleForm.lb_value" size="small" :props="lb_props" :options="lb_options">
                        </el-cascader>
                    </el-form-item>
                    <!-- <el-form-item label="可见" prop='kj_value'>
                        <el-select v-model="ruleForm.kj_value" placeholder="请选择" size="small" filterable>
                            <el-option v-for="item in  kj_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="图片" required>
                        <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                            :headers="{ 'token':$store.state.user.token }"
                            :data="{ image_class_id:'72',file_type:'1',userId:this.ruleForm.ry_value }"
                            :file-list="ruleForm.lb_mapList" :before-upload="beforeUpload" :on-success="uploadSuccess"
                            :limit="1" :on-remove="uploadRmove" list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="标题" prop='title'>
                        <el-input v-model="ruleForm.title" placeholder="请输入关键词" size="small" class="zwidth">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="内容" prop="textarea">
                        <el-input type="textarea" :rows="15" placeholder="请输入内容" v-model="ruleForm.textarea">
                        </el-input>
                        <!-- <tinymce ref="editor" v-model="ruleForm.textarea" @onClick="onClick"
                            toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" /> -->
                    </el-form-item>

                    <!-- <el-form-item label="发布设置" prop='lb_put'>
                        <el-radio-group v-model="ruleForm.lb_put">
                            <el-radio :label="1" style="width:100%;margin-bottom:0px">立即发布</el-radio>
                            <div>
                                <el-radio :label="2">定时发布</el-radio>
                                <el-date-picker v-model="ruleForm.lb_dstime" :clearable="false"
                                    :disabled="ruleForm.lb_put==2?false:true" size="mini" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间" default-time="12:00:00">
                                </el-date-picker>
                            </div>
                            <el-radio :label="3" style="width:100%">暂不发布</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="详情" :visible.sync="detaildialogVisible" center top="20px" width="70%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="getruleForm" :rules="plrule" ref="ruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="用户:">
                                <p class="yhname">{{getruleForm.rytext}}</p>
                            </el-form-item>

                            <el-form-item label="分类:">
                                <p>{{getruleForm.ht_value2}}</p>
                            </el-form-item>
                            <el-form-item label="内容:">
                                <p class="con_de" v-html="getruleForm.textarea"></p>
                            </el-form-item>
                            <el-form-item label="图片:" style="margin-top:10px">
                                <div class="u-f u-wrap">
                                    <el-image style="width: 50px; height: 50px;margin-right:2px"
                                        v-for="(img,index) in getruleForm.images" :key="index" :src="img.url"
                                        :fit="'cover'" :preview-src-list="[img.url]"></el-image>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span='12'>
                            <el-form-item label="医生" prop='ry_value2'>
                                <el-select v-model="getruleForm.ry_value2" placeholder="请选择" size="small" filterable
                                    @change="selectry">
                                    <el-option v-for="item in  ry_options" :key="item.id"
                                        :label="item.real_name+'--'+item.sex_text" :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="赞一下">
                                <div class="zanbtn" @click="dzan">
                                    <img v-if="!zan" src="../../../assets/imgs/zan.png" alt="">
                                    <img v-else src="../../../assets/imgs/zan2.png" alt="">
                                </div>
                            </el-form-item>
                            <el-form-item label="评论" prop='pltext'>
                                <el-input type="text" placeholder="评论一下" v-model="getruleForm.pltext">
                                </el-input>
                            </el-form-item>
                            <el-form-item label="评论:">
                                <div class="lefts" v-if="listItem&&listItem.length>0">
                                    <el-timeline :reverse="true">
                                        <el-timeline-item v-for="(item,index) in listItem" :key="index"
                                            :timestamp="item.create_time" placement="top">
                                            <div class="concon">
                                                <div class="u-f u-ac u-jsb">
                                                    <div class="u-f u-ac u-jsb" style="width:100%">
                                                        <div class="u-f u-ac">
                                                            <img :src="item.is_fictitious_user==1?item.avatar:item.avatar"
                                                                alt="" class="imgs">
                                                            <div>
                                                                {{item.is_fictitious_user==1?item.create_user_text:item.create_user_text}}
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <i class="el-icon-delete reds" @click="delclick(item)"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="">{{item.reply_content}}</div>
                                            </div>
                                        </el-timeline-item>
                                    </el-timeline>
                                </div>
                                <div v-else>
                                    暂无评论
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="plsubmit" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="detaildialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 审核 -->
        <el-dialog title="审核" :visible.sync="examdialogs" top="40px" width="70%" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="examForm" :rules="rule" ref="examForm" label-width="150px" v-loading='examloading'
                    class="demo-ruleForm forms-lines">
                    <el-form-item label="标题：">
                        <span>{{examForm.name}}</span>
                    </el-form-item>
                    <el-form-item label="图片：">
                        <div class="u-f u-wrap">
                            <el-image style="width: 50px; height: 50px;margin-right:2px"
                                v-for="(img,index) in examForm.titlepic" :key="index" :src="img.url" :fit="'cover'"
                                :preview-src-list="[img.url]"></el-image>
                        </div>
                    </el-form-item>
                    <el-form-item label="内容：">
                        <div class="con_b">
                            <span v-html="examForm.content"></span>
                        </div>
                    </el-form-item>
                    <el-form-item label="审核：">
                        <el-radio-group v-model="examForm.examradio">
                            <el-radio :label="1">审核通过</el-radio>
                            <el-radio :label="2">审核不通过</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item v-if="examForm.examradio==2" label="拒绝理由：">
                        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="examForm.remark">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="examsubmit()" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="examdialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!--  -->
        <el-dialog :visible.sync="dialog_prev" width="60vw" top="5vh">
            <div style="margin: -60px -20px -30px -20px;">
                <img :src="urls" class="w-100" />
            </div>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import tinymce from '@/components/common/tinymce.vue';
    export default {
        components: {
            tinymce,
        },
        data() {
            return {
                lb_value: '',
                lb_options: [],
                lb_props: {
                    label: "name",
                    value: "id",
                    children: 'child'
                },
                kj_options: [{
                    name: '所有人可见',
                    id: 1
                }, {
                    name: '仅自己可见',
                    id: 0
                }, ],
                ht_options: [],
                ht_options2: [],
                ry_options: [],
                loading: false,
                tableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 10,
                height: null,
                // 
                eid: '0',
                dialogVisible: false,
                detaildialogVisible: false,
                subloading: false,
                dataId: '',
                listItem: [],

                ruleForm: {
                    lb_value: '',
                    title: '',
                    lb_dstime: '',
                    lb_put: 1,
                    lb_mapList: [],
                    kj_value: '',

                    ht_value: '',
                    ht_value2: '',
                    ry_value: '',
                    textarea: '',
                },
                getruleForm: {
                    rytext: '',
                    pltext: '',
                    ht_value2: '',
                    textarea: '',
                    kj_value: '',
                    lb_value: '',
                    images: '',
                    ry_value2: '',


                },
                zan: false,
                mapListed: [],
                rule: {
                    lb_value: [{
                        required: true,
                        message: '请选择类别',
                        trigger: 'blur'
                    }],
                    kj_value: [{
                        required: true,
                        message: '请选择谁可见',
                        trigger: 'blur'
                    }],

                    textarea: [{
                        required: true,
                        message: '请填写内容',
                        trigger: 'blur'
                    }],
                    ry_value: [{
                        required: true,
                        message: '请选择人员',
                        trigger: 'blur'
                    }],

                    ht_value: [{
                        required: true,
                        message: '请选择话题类型',
                        trigger: 'blur'
                    }],
                    ht_value2: [{
                        required: true,
                        message: '请选择话题列表',
                        trigger: 'blur'
                    }],
                    title: [{
                        required: true,
                        message: '请填写关键词',
                        trigger: 'blur'
                    }],
                    lb_put: [{
                        required: true,
                        message: '请选择发布设置',
                        trigger: 'blur'
                    }],
                },
                plrule: {
                    ry_value2: [{
                        required: true,
                        message: '请选择人员',
                        trigger: 'blur'
                    }],
                },
                // 
                dialog_prev: false,
                urls: '',
                topic_child_options: [],
                selectUserdata: '',
                doc_options: [],
                examForm: {
                    remark: '',
                    examradio: '',
                    content: '',
                    name: '',
                    department: [],
                    user_value: '',
                    commission: 0,
                    titlepic: []
                },
                examloading: false,
                examdialogs: false,
                xndoc_data: ''
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        created() {
            this.getxnUser()
        },
        mounted() {
            let that = this
            this.begin()
            that.getHeight()
            that.getlbxx()
            this.getdoc()

        },
        methods: {
            getdoc() {
                axios
                    .post("/admin/doctorAssistantList", {
                        type: 9
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.doc_options = response.data.data
                    })
                    .catch(error => {})
            },
            getxnUser() {
                this.axios
                    .post(
                        "/admin/h5/fictitiousUsers", {
                            page: 1,
                            page_count: 100
                        }, {
                            token: true
                        }
                    )
                    .then((res) => {
                        this.ry_options = res.data.data.list
                    })
                    .catch((err) => {

                    });
            },
            selectUser(val) {
                this.ry_options.forEach(e => {
                    if (e.id == val) {
                        this.selectUserdata = e
                    }
                })
            },
            handleDelete() {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let url = `/admin/pc/delPost`
                    axios.post(url, {
                        id: this.dataId
                    }, {
                        token: true
                    }).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                        } else {

                        }
                    })

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });


            },
            getinfo() {
                let that = this
                axios
                    .post(`/admin/AllComment/getComments`, {
                        data_id: this.dataId,
                        source: 6,
                        page: 1,
                        page_count: 1000
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.listItem = response.data.data.list

                    })
                    .catch(error => {})
            },
            selectry(val) {
                this.zan = false
                this.ry_options.forEach(ele => {
                    if (ele.id == val) {
                        this.xndoc_data = ele
                    }
                })
            },
            dzan() {
                if (!this.getruleForm.ry_value2) {

                    this.$message({
                        message: '请先选择人员哦',
                        type: 'warning'
                    });
                    return

                }
                axios.post('/admin/community/praise', {
                    create_user: this.getruleForm.ry_value2,
                    data_id: this.dataId,
                    source: 7,
                    type: 1,
                }, {
                    token: true
                }).then(res => {
                    if (res.data.code == 200 && res.data.errorCode == 999) {
                        this.$message({
                            message: '已经赞过了',
                            type: 'success'
                        });
                    } else {
                        this.$message({
                            message: '点赞成功',
                            type: 'success'
                        });

                        this.zan = true
                    }
                })

            },
            handle_top(row, val) {
                axios
                    .post("/admin/community/update", {
                        id: row.id,
                        is_top: val
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.$message({
                                type: 'success',
                                message: '操作成功!'
                            });
                            this.search()
                        } else {
                            this.$message.error(response.data.message);
                        }
                    })
                    .catch(error => {})
            },
            beforeUpload() {
                if (!this.ruleForm.ry_value) {
                    this.$message({
                        message: '请先选择人员哦',
                        type: 'warning'
                    });
                    return false
                }
            },
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 10
                that.search()
            },
            search() {

                let that = this
                that.tableData = []
                that.loading = true
                axios.post(`/admin/community/list`, {
                        user_id: '',
                        page: that.currentPage,
                        page_count: this.pagesize,
                        manager_id: '',
                        category_id: this.lb_value[this.lb_value.length - 1]
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount

                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = '0'
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm.lb_value = ''
                that.ruleForm.lb_put = 1
                that.ruleForm.lb_dstime = ''
                that.ruleForm.textarea = ''
                this.ruleForm.title = ''
                that.ruleForm.kj_value = ''
                that.ruleForm.ht_value2 = ''
                that.ruleForm.lb_mapList = []
                that.ruleForm.ry_value = ''
                that.ruleForm.ht_value = ''
                that.mapListed = []
            },
            // 鼠标单击的事件
            onClick(e, editor) {},
            submit(formName) {
                let that = this
                var time;
                // if (that.ruleForm.lb_put == '1') {
                //     time = that.gettimes()
                // } else if (that.ruleForm.lb_put == '2') {
                //     time = that.ruleForm.lb_dstime
                // } else {
                //     time = that.ruleForm.lb_put
                // }
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        let arr1 = []
                        let obj = {}
                        // that.mapListed.forEach(ele => {
                        //     obj = {
                        //         id: ele.id
                        //     }
                        //     arr1.push(obj)
                        // })
                        // if (that.mapListed.length < 1) return that.$message.error('请上传图文封面');
                        that.subloading = true
                        let urls;
                        if (this.eid && this.eid != '0') {
                            urls = "/admin/community/update"
                        } else {
                            urls = "/admin/community/save"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                titlepic: that.mapListed,
                                content: this.ruleForm.textarea,
                                // isopen: 1,
                                // to_show: that.ruleForm.lb_put,
                                // show_time: time,
                                category_id: Array.isArray(that.ruleForm.lb_value) ? that.ruleForm
                                    .lb_value[that.ruleForm.lb_value.length - 1] : that.ruleForm.lb_value,
                                user_id: this.ruleForm.ry_value,
                                title: this.ruleForm.title,
                                manager_id: this.user.id,
                                status: 1,
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            //编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                this.ruleForm.lb_mapList = []
                this.mapListed = []
                this.mapListed = row.titlepic
                this.ruleForm.lb_mapList = row.titlepic
                that.dialogVisible = true
                that.eid = row.id
                // that.ruleForm.ht_value = row.post_class_id
                // that.selecthttit()
                that.ruleForm.lb_value = row.category_id
                that.ruleForm.textarea = row.content
                that.ruleForm.kj_value = row.isopen
                this.ruleForm.lb_dstime = row.show_time
                this.ruleForm.lb_put = row.to_show
                that.ruleForm.ry_value = row.user.id


                // var ry_id = that.ry_options.find(function (x) {
                //     return x.id == row.user_id
                // }).id
                // if (ry_id) {
                //     that.ruleForm.ry_value = row.user_id
                // } else {
                //     that.ruleForm.ry_value = ''
                // }
                that.ruleForm.title = row.title
                that.ruleForm.ht_value2 = row.topic_id
            },

            plsubmit() {
                if (!this.getruleForm.ry_value2) {
                    this.$message({
                        message: '请先选择人员哦',
                        type: 'warning'
                    });
                    return
                }
                if (!this.getruleForm.pltext) {
                    this.$message({
                        message: '评论不能为空',
                        type: 'warning'
                    });
                    return
                }
                axios.post('/admin/community/comment', {
                    avatar: 'https://api.kkxxkj.cn/storage/background/tourist.png',
                    reply_content: this.getruleForm.pltext,
                    author: this.getruleForm.ry_value2,
                    data_id: this.dataId,
                    create_user_text: this.xndoc_data.real_name,
                    source: 6,
                    is_fictitious_user: 1
                }, {
                    token: true
                }).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: '评论成功',
                            type: 'success'
                        });
                        this.detaildialogVisible = false
                    }
                })
            },
            detailbtn(row, index) {
                this.dataId = row.id
                this.zan = false
                this.detaildialogVisible = true
                this.getinfo()
                this.getruleForm.rytext = row.user.nickname
                this.getruleForm.pltext = ''
                this.getruleForm.ry_value2 = ''
                this.getruleForm.ht_value2 = row.category.category_name
                this.getruleForm.images = row.titlepic
                let obj = {}
                // row.images.forEach(ele => {
                //     obj = {
                //         url: ele.url
                //     }
                //     this.getruleForm.images.push(obj)
                // })
                this.getruleForm.textarea = row.content.replace(/\n/g, '<br>')
                this.getruleForm.kj_value = row.isopen
                this.getruleForm.ry_value = ''
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/community/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            gettimes() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                let hour = nowDate.getHours(); //获取系统时，
                let min = nowDate.getMinutes(); //分
                let sec = nowDate.getSeconds(); //秒
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                hour = hour > 9 ? hour : '0' + hour
                min = min > 9 ? min : '0' + min
                sec = sec > 9 ? sec : '0' + sec
                return `${year}-${month}-${day} ${hour}:${min}`;
            },
            // 类别
            getlbxx() {
                let that = this
                that.lb_options = []
                axios
                    .post("/admin/communityDoctor/categoryHead", {
                        noChild: 1
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.lb_options = response.data.data
                    })
                    .catch(error => {})
            },

            // 获取话题类
            gethtlist() {
                let that = this
                axios
                    .get("/admin/pc/topicclass", {
                        'token': true
                    })
                    .then(response => {
                        that.ht_options = response.data.data.list

                    })
                    .catch(error => {})
            },
            // // 获取话题列表
            // selecthttit() {
            //     let that = this
            //     this.ruleForm.ht_value2 = ''
            //     axios
            //         .get(`/admin/pc/topicclass/${this.ruleForm.ht_value}/topic/1?userId=${this.user.id}&all=1`, {
            //             'token': true
            //         })
            //         .then(response => {
            //             that.ht_options2 = response.data.data.list

            //         })
            //         .catch(error => {})
            // },
            // 获取话题列表
            edit_selecthttit(topic_id) {
                let that = this
                that.topic_child_options = [];
                axios
                    .get(`/admin/pc/topicclass/${topic_id}/topic/1?userId=${this.user.id}&all=1`, {
                        'token': true
                    })
                    .then(response => {
                        that.topic_child_options = response.data.data.list

                    })
                    .catch(error => {})
            },
            goprev(item) {
                let that = this
                that.dialog_prev = true
                that.urls = item
            },
            // 
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
            delclick(row) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/community/commentDel", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getinfo()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleexam(index, row) {
                this.examdialogs = true
                this.eid = row.id
                this.examdata = row
                this.examForm.name = row.title
                this.examForm.remark = row.examine_remark
                this.examForm.examradio = row.status
                this.examForm.titlepic = row.titlepic
                this.examForm.content = row.content.replace(/\n/g, '<br>')

            },
            // 审核
            examsubmit() {
                if (this.examForm.examradio == 2 && this.examForm.remark == '') {
                    this.$message({
                        message: '请输入拒绝理由',
                        type: 'warning'
                    });
                    return
                }

                let params = {}
                let urls = ''

                urls = '/admin/community/examine'
                params = {
                    id: this.eid,
                    status: this.examForm.examradio,
                    examine_remark: this.examForm.remark,
                }
                this.examloading = true
                axios
                    .post(urls, params, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == 200) {
                            this.$message({
                                message: '操作成功',
                                type: 'success'
                            });
                            this.examdialogs = false
                            this.search()
                        } else {
                            this.$message({
                                message: response.data.msg,
                                type: 'warning'
                            });
                        }
                        this.examloading = false
                    })
                    .catch(error => {})
            },

        },

    };
</script>


<style>
    .con_de {
        /* border: 1px solid red; */
        /* width: 200px; */
        width: 100%;
        max-height: 200px;
        overflow-y: scroll;
        line-height: 18px;
        position: relative;
        top: 7px;
        background-color: rgb(247, 245, 245);
        border-radius: 5px;
        padding: 5px;
    }

    .imgs {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        margin-right: 5px;
    }

    .lefts {
        max-height: 500px;
        overflow: auto;
    }

    .delt {
        color: red;
        font-size: 20px;
    }

    .blues {
        color: #409eff;
    }

    .concon {
        background: #f5f5f5;
        padding: 10px;
        border-radius: 10px;
    }

    .zanbtn {
        width: 30px;
        display: flex;
        /* border: 1px solid red; */
        cursor: pointer;
    }

    .zanbtn img {
        width: 100%;
        display: block;
    }

    .singleimg {
        width: 100px;
        width: 100px;
    }

    .singleimg img {
        width: 100%;
        height: 100%;
        display: block;
    }

    .imgbox {
        display: flex;
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .tablimg {
        margin: 2px 5px;
    }
</style>